import { GET_ISSUE_BY_ID } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_ISSUE_BY_ID.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_ISSUE_BY_ID.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case GET_ISSUE_BY_ID.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
